import { fetchApi } from "infrastructure/api";
import type { ID } from "types";
import { HttpVerb } from "consts/api";
import { ApiRoutes } from "consts/enpoints/api";
import type {
    OnboardingApplication,
    OnboardingRequestParams,
    OnboardingPaymentMethod,
    PreApplicationOnboarding,
    ResendPreapplicationVerifyLink
} from "features/ecommerce/types";

export const getOnboardingUserById = (userId: ID) =>
    fetchApi(ApiRoutes.GetOnboardingsUsers(userId));

export const getOnboardingsConstants = () =>
    fetchApi(ApiRoutes.GetOnboardingsConstants());

export const getOnboardingsCountries = (query = '') =>
    fetchApi(`${ApiRoutes.GetOnboardingsCountries()}${query}`);

export const getOnboardingsPaymentMethods = (query = '') =>
    fetchApi(`${ApiRoutes.GetOnboardingsPaymentMethods()}${query}`);

export const postOnboardingRegister = (body: Partial<PreApplicationOnboarding>) =>
    fetchApi(ApiRoutes.PostOnboardingsRegister, {
        method: HttpVerb.Post,
        body
    });
export const resendPreapplicationVerifyLink = (body: ResendPreapplicationVerifyLink) =>
    fetchApi(ApiRoutes.ResendOnboardingRegistrationVerificationLink, {
        method: HttpVerb.Post,
        body
    });

export const getOnboardingsApplications = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsApplications(userId));

export const putOnboardingsApplications = <TApplication extends object>(body: OnboardingRequestParams & Partial<OnboardingApplication<TApplication>>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsApplications(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const postOnboardingsApplications = <TApplication extends object>(body: OnboardingRequestParams & Partial<OnboardingApplication<TApplication>>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PostOnboardingsApplications(userId), {
        method: HttpVerb.Post,
        body
    });
};

export const getOnboardingsPaymentMethodsSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsPaymentMethodsSteps(userId));

export const putOnboardingsPaymentMethodsSteps = (body: OnboardingRequestParams & Partial<OnboardingPaymentMethod>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsPaymentMethodsSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};
